export const ParentReferralListPath = '/referral/parent/list'
export const ChildReferralListPath = '/referral/child/list'
export const ParentReferralDetailPath = '/referral/parent/view'
export const ChildReferralDetailPath = '/referral/child/view'
export const ParentReferralEditPath = '/referral/parent/edit'
export const ChildReferralEditPath = '/referral/child/edit'
export const ParentReferralAddPath = '/referral/parent/add'
export const ChildReferralAddPath = '/referral/child/add'
export const ParentReferralEditPathNew = '/referral/parent/editRef'
export const ChildReferralEditPathNew = '/referral/child/editRef'
export const ParentReferralAddPathNew = '/referral/parent/addRef'
export const ChildReferralAddPathNew = '/referral/child/addRef'
export const ParentReferralQuestionAnswerPath = '/referral/parent/question-answer'
export const ChildReferralQuestionAnswerPath = '/referral/child/question-answer'
export const ChildMessageFromSourcePath = '/referral/child/message-from-source'
export const ChildReferralUpdatesFromSourcePath = '/referral/child/referral-updates'
export const QueuedParentReferralEditPath = '/referral/parent/queued/edit'
export const QueuedChildReferralEditPath = '/referral/child/queued/edit'
// Temporary debug paths for the in-progress Queued Referral revamp. The legacy
// `QueuedParent/ChildReferralEditPath` constants will be repointed to the new
// component in the final phase, after parity verification.
export const QueuedParentReferralEditRevampPath = '/referral/parent/queued/edit-revamp'
export const QueuedChildReferralEditRevampPath = '/referral/child/queued/edit-revamp'
export const DiscussionPath = '/discussions'
export const RefDiscussionPath = '/referral/chatView'

export const LeadListPath = '/leads/list'
export const LeadAddPath = '/leads/add'
export const LeadDetailPath = '/leads/view'
export const LeadEditPath = '/leads/edit'
export const LeadArchivedPath = '/leads/archived'

export const CrmAccountsListPath = '/crm-accounts/list'
export const CrmAccountDetailPath = '/crm-accounts/view'
export const CrmMapSourcePath = '/crm-accounts/map'
